(() => {
  'use strict';

  const currentScript = document.currentScript;
  const currentSrc = currentScript?.src || '';
  const coreSrc = currentScript?.dataset.coreSrc || currentSrc.replace('puane-b2b-product-v3.js', 'puane-b2b-product-v3-core.js');

  const filterColorCards = () => {
    document.querySelectorAll('[data-pb2b-root]').forEach((root) => {
      const cards = [...root.querySelectorAll('[data-pb2b-color]')];

      cards.forEach((card) => {
        card.hidden = false;
        card.disabled = false;
        card.setAttribute('aria-hidden', 'false');
      });

      root.querySelectorAll('[data-pb2b-row]').forEach((row) => {
        row.hidden = false;
        row.setAttribute('aria-hidden', 'false');
      });

      const activeCard = cards.find((card) => card.classList.contains('is-active'));
      if (!activeCard && cards[0]) cards[0].click();

      const colorPanel = root.querySelector('.pb2b__color-panel');
      if (colorPanel) colorPanel.hidden = cards.length === 0;
    });
  };

  if (!coreSrc || coreSrc === currentSrc) {
    filterColorCards();
    return;
  }

  const script = document.createElement('script');
  script.src = coreSrc;
  script.async = false;
  script.addEventListener('load', filterColorCards, { once: true });
  script.addEventListener('error', filterColorCards, { once: true });
  document.head.appendChild(script);
})();
